export const CSS = {
  container: "container",
  hexInput: "hex-input",
  opacityInput: "opacity-input",
};
